<template>
  <div>
    <import-form
      :subject="$translate('user')"
      v-model="importModal"
      @cancel="hideModal()"
      :fields="userFields"
      :upload-record="uploadUserRecord"
      settings-key-name="userUploadKey"
    ></import-form>

    <view-user v-if="!!item" :item="item" @toast="userCreated()"></view-user>

    <users-table title="Users" @addUser="showUserModal()" ref="userTable">
      <div
        class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
      >
        <b-button
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$addLabel()"
          v-if="hasPermissionCreate"
          @click="createUser()"
        >
          <img src="@/assets/images/icon/gradient-add.svg"
        /></b-button>

        <b-button
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$translate('import')"
          @click="importModal = true"
          v-if="hasPermissionCreate"
        >
          <img src="@/assets/images/icon/import.svg" />
        </b-button>
      </div>
    </users-table>
  </div>
</template>
<script>
import UsersTable from "./Users/UsersTable";
import utilityMixins from "@/mixins/utilityMixins";
import ViewUser from "./Users/ViewUser";
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";
import ImportForm from "@/components/ImportForm.vue";
import importMixins from "@/mixins/importMixins";

const userFields = [
  { name: "firstName", label: "firstName", required: true, type: "text" },
  {
    name: "lastName",
    label: "lastName",
    required: true,
    type: "text",
  },
  {
    name: "email",
    label: "email",
    required: true,
    type: "email",
  },
  {
    name: "role",
    label: "role",
    required: true,
    type: "text",
  },
  {
    name: "password",
    label: "password",
    required: true,
    type: "text",
  },
];

export default {
  name: "users",
  components: {
    UsersTable,
    ViewUser,
    ImportForm,
  },
  mixins: [popupMixins, utilityMixins, permissionsMixins, importMixins],
  data: () => {
    return {
      componentName: "User",
      item: null,
      importModal: false,
      userFields,
    };
  },
  computed: {
    user_permissions() {
      return this.$store.getters.user_permissions;
    },
  },

  methods: {
    createUser() {
      const id = 0;
      this.$router.push({ params: { id }, name: "viewUsers" });
    },
    // userCreated() {
    //     this.genericToast(
    //         this.componentName,
    //         status,
    //         'success',
    //         `${this.componentName} ${status.toLowerCase()} succcessfully`
    //     )
    //     this.item = null
    //     this.$refs.userTable.doSearch()
    // },
    async uploadUserRecord(
      dataRecord,
      statusRecord,
      { check, message, field },
      statuses,
      setLoading
    ) {
      try {
        let { firstName, lastName, email, role, password } = dataRecord;

        statusRecord.status = statuses.CHECKING;
        console.log("field", field);

        if (check != 1) throw new Error(`${this.$translate(field)}-${message}`);

        const roles = [role];

        const param = {
          firstName,
          lastName,
          email,
          password,
          roles,
        };
        console.log("param:", param);

        const res = await this.$store.dispatch("users/createUser", param);
        console.log("response:", res);
        // set status to complete if the upload was successful
        statusRecord.status = statuses.COMPLETE;
      } catch (err) {
        console.error("err", err);
        statusRecord.error_list =
          typeof err.message == "string"
            ? [["error", [err.message]]]
            : Object.entries(err.message);
        statusRecord.status = statuses.ERROR;
      } finally {
        setLoading(false);
      }
    },
  },

  mounted() {},
};
</script>
<style></style>
